import store from '../store'
import {isHealthSpecialist} from "@/utils/Specialist";

export const getLabel = (key = '') => {

    const institutionId = store.state.currentProvider &&
        store.state.currentProvider.institution &&
        store.state.currentProvider.institution.id || null

    let strings
    if(!institutionId){
        strings = isHealthSpecialist() ? require('./locals/health') : require('./locals/others')
    }else{
        strings = isHealthInstitution(institutionId) ? require('./locals/health') : require('./locals/others')
    }

    const foundString = getStringFromKey(strings, key)

    return foundString

}

const getStringFromKey = (obj, key = '') => {

    var strKeys = key.split('.')
    var rootKey = strKeys.shift()
    var match = obj[rootKey]

    if(match){

        if(strKeys.length === 0){

            if(typeof match !== 'string'){
                return 'NOT_STRING'
            }

            return match
        }

        const newKey = strKeys.join('.')
        return getStringFromKey(match, newKey)

    }else{
        return 'STRING_NOT_FOUND'
    }

}

export const isHealthInstitution = (institutionId = 1) => {
    const health = [1,2,3]
    return health.includes(institutionId)
}

export const HOSPITAL_TYPE = 1
export const OPHTHALMOLOGIST_TYPE = 2

export const getInstitutionType = () => {

    const institutionTypeId = store.state.currentProvider &&
        store.state.currentProvider.institution &&
        store.state.currentProvider.institution.institution_type_id || null

    return institutionTypeId;

}
